<template>
  <div id="app" class="container">
    <div>
      <b-navbar class="b-navbar-bg" toggleable="md" type="dark">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

        <b-collapse is-nav id="nav_collapse">
          <b-navbar-nav>
            <router-link to="/" class="nav-link" active>Home</router-link>
            <!-- <router-link to="/ptownflags" class="nav-link">Ptown Flags</router-link> -->
            <!-- <router-link to="/spadefoottoad" class="nav-link">Spadefoot Toad Research</router-link> -->
            <router-link
              v-if="userIsAuthenticated"
              to="/ptownflags"
              class="nav-link"
              >Ptown Flags</router-link
            >
            <router-link
              v-if="userIsAuthenticated"
              to="/creekroad"
              class="nav-link"
              >Creek Road Conservation
            </router-link>

            <!-- <router-link to="/greenarea" class="nav-link"
              >Green Area
            </router-link> -->

            <router-link to="/ptownprops" class="nav-link"
              >Ptown Property Search
            </router-link>
            <!-- <router-link v-if="userIsAuthenticated" to="/ptownflags" class="nav-link">Ptown Flags</router-link>
            <router-link v-if="userIsAuthenticated" to="/creekroad" class="nav-link">Creek Road Conservation
            </router-link> -->
            <!-- <router-link v-if="userIsAuthenticated" to="/spadefoottoad" class="nav-link">Spadefoot Toad Research
             -->
          </b-navbar-nav>
        </b-collapse>

        <form class="form-inline my-2 my-lg-0">
          <router-link
            v-if="!userIsAuthenticated"
            to="/signin"
            class="btn btn-outline-success my-2 my-sm-0"
            >Sign In
          </router-link>

          <button
            class="btn btn-outline-warning my-2 my-sm-0"
            v-if="userIsAuthenticated"
            @click="onLogout"
          >
            Sign Out
          </button>
        </form>

        <!-- <form class="form-inline my-2 my-lg-0">
          <router-link v-if="!userIsAuthenticated" to="/signin" class="btn btn-outline-success my-2 my-sm-0">Sign In
          </router-link>

          <button class="btn btn-outline-warning my-2 my-sm-0" v-if="userIsAuthenticated" @click="onLogout">Sign
            Out</button>
        </form> -->
      </b-navbar>

      <router-view />

      <div>
        <div class="container">
          <div class="footer">
            <footer>
              Copyright &copy; 2019 &mdash; 2023 by Provincetown.app
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userName: {},
    };
  },
  computed: {
    userIsAuthenticated() {
      this.userName = this.$store.getters.user;
      console.log("User Name: ", this.$store.getters.user);
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
  },
  methods: {
    onLogout() {
      this.$store.dispatch("logout");
      // https://router.vuejs.org/guide/essentials/navigation.html
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style>
html {
  overflow-y: scroll;
}

/* body {
    background: url('./assets/images/flags/PtownFlags_01.png') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover;
    -o-background-size: cover;
  } */

/* body {
    background: url('./assets/images/flags/PtownFlags_01.png') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    background-size: cover;
    -o-background-size: cover;
  } */

.bg {
  /* The image used */
  /* background-image: url("./assets/images/flags/PtownFlags_01.png"); */

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.footer {
  position: fixed;
  font-size: 0.8em;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: grey;
  color: white;
  text-align: center;
}

.b-navbar-bg {
  background-color: black;
  /* color: white; */
}

.nav-link {
  font-weight: bold;
}

* {
  box-sizing: border-box;
}

/* ---- grid ---- */

.grid {
  background: #ddd;
}

/* clear fix */
.grid:after {
  content: "";
  display: block;
  clear: both;
}

/* ---- .grid-item ---- */

.grid-sizer,
.grid-item {
  width: 33.333%;
}

.grid-item {
  float: left;
}

.grid-item img {
  display: block;
  max-width: 100%;
}
</style>
